import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Generuje nowe PIN-y wszystkim klientom; CSV z PIN-ami pobierany jednorazowo (w bazie tylko hash).
export function RegeneratePinsButton({ t }) {
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!window.confirm(t("Wygenerować NOWE PIN-y dla wszystkich klientów? Stare PIN-y i sesje portalu przestaną działać. Plik CSV z PIN-ami pobierzesz tylko raz."))) return;
    setBusy(true);
    try {
      const res = await api.post("/clients/regenerate-pins", {}, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = "nowe_piny_klientow.csv"; a.click();
      URL.revokeObjectURL(url);
      toast.success(`${t("Wygenerowano nowe PIN-y")}: ${res.headers["x-count"] || ""}`);
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={run} disabled={busy} data-testid="regenerate-all-pins-btn"
      className="w-full sm:w-auto bg-amber-700 hover:bg-amber-600 rounded px-3 py-2 text-xs font-medium flex items-center justify-center gap-2 mt-1 disabled:opacity-60">
      {busy ? <Loader2 size={14} className="animate-spin" /> : <KeyRound size={14} />} {t("Nowe PIN-y dla wszystkich klientów (CSV)")}
    </button>
  );
}
